import { Action, Reducer } from 'redux';
import {
  ReportTemplateTypeState,
  ReportTemplateTypeTypes,
  ReportTemplateTypeActionTypes
} from './reportTemplateTypeTypes';
import { haskeyReducer, updateGetIsolated, updateSaveIsolated } from '@/main/services/reducerUtils';

export const INITIAL_STATE: ReportTemplateTypeState = {
  reportTemplateType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const reportTemplateTypeReducer: Reducer<ReportTemplateTypeState> = (
  state: ReportTemplateTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ReportTemplateTypeActionTypes;
  switch (actionTypes.type) {
    case ReportTemplateTypeTypes.GET_REPORT_TEMPLATE_TYPE:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        reportTemplateType: { ...state.reportTemplateType, isLoading: true }
      };
    case ReportTemplateTypeTypes.SAVE_REPORT_TEMPLATE_TYPE:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

      return {
        ...state,
        reportTemplateType: {
          ...state.reportTemplateType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case ReportTemplateTypeTypes.RESET_REDUCER_REPORT_TEMPLATE_TYPE:
      return {
        ...state,
        reportTemplateType: INITIAL_STATE.reportTemplateType
      };
    default:
      return state;
  }
};

export default reportTemplateTypeReducer;

